<template>
  <div class="sv sv013">
    <div class="container">
      <breadcrumb-group :items="breadcrumbItems"/>

      <contents-header class="-orange" src="sv013/main.jpg">
        <p class="heading1">auサービスでもっとおトクに！</p>
        <h1 class="heading2">携帯電話の料金を見直して<br>おトクに節約！</h1>
      </contents-header>
    </div>

    <div class="container">
      <contents-intro
        class="-orange _pt-sm-60"
        icon-left="sv013/avatar-a.gif"
        name-left="Aさん"
        icon-right="sv013/avatar-b.gif"
        name-right="Bさん"
        txt-relation="同僚の2人">
        お給料日前はいつも家計が苦しい…という方も少なくないはず。<br>
        Bさんもその中の一人で、やりくり上手な同僚のAさんに相談します。
      </contents-intro>
    </div>

    <hr class="-pcnone _mb-sm-60">

    <div class="container">

      <heading-two class="_mt-md-110 _mt-sm-60">家計の見直しは「固定費」から！</heading-two>

      <talk-group class="_mb-md-60 _mb-sm-40">
        <talk-box src="sv013/avatar-b.gif">お給料日前で今月もまたおサイフがピンチだよ！貯金もできてないし、そろそろ色々見直さなきゃ</talk-box>
        <talk-box src="sv013/avatar-a.gif">だったら、毎月必ず一定額の支出がある『固定費』をチェックしてみるといいよ</talk-box>
      </talk-group>

      <contents-card class="-orange _mb-sm-30">
        <div class="card-header">
          <icon-box src="light-orange" class="-md _mb-sm-10"></icon-box>
          <h3 class="heading -orange">固定費にはこんなものがある！</h3>
        </div>
        <div class="card-body _pt-md-30">
          <div class="card-groups">
            <div class="card-box order2">
              <div class="card-image _mb-sm-20">
                <img src="@/assets/images/sv/sv013/img01.gif" class="img-fluid" alt="">
              </div>
            </div>
            <div class="card-box _pl-md-60 order1 _ml-md-20">
              <div class="card-body">
                <list-group class="-normal _mb-md-50">
                  <list-item class="-normal">家賃</list-item>
                  <list-item class="-normal">電気代</list-item>
                  <list-item class="-normal">ガス代</list-item>
                  <list-item class="-normal">水道代</list-item>
                  <list-item class="-normal">生命保険料</list-item>
                  <list-item class="-normal">スマートフォン・携帯電話の料金</list-item>
                  <list-item class="-normal">インターネットの回線料</list-item>
                  <list-item class="-normal">駐車場代</list-item>
                </list-group>
              </div>
            </div>
          </div>
        </div>
      </contents-card>

      <talk-group>
        <talk-box src="sv013/avatar-a.gif">固定費には銀行口座から自動で引き落とされているものもあるから、請求内容をよく理解しないまま支払っていることもあるんじゃない？</talk-box>
        <talk-box src="sv013/avatar-b.gif">言われてみればそうかも…。電気代とか、携帯電話の料金とかあまり気にしていないな…</talk-box>
      </talk-group>

      <heading-two class="_mt-md-110 _mt-sm-60">スマートフォン料金プランの見直しで固定費の節約ができる！</heading-two>

      <talk-group src="sv013/img02.jpg" class="_mb-md-60 _mb-sm-40">
        <talk-box src="sv013/avatar-a.gif">固定費の中には家賃のように見直しが難しいものがあるけど、携帯電話の料金は見直しをしやすい固定費なの！</talk-box>
        <talk-box src="sv013/avatar-b.gif">そういえば、最初に契約した時のままだな…</talk-box>
        <talk-box src="sv013/avatar-a.gif">それなら料金プランを見直すと、毎月の出費をぐっと減らせるかもしれないね</talk-box>
      </talk-group>

      <heading-two class="_mt-md-110 _mt-sm-60">自分にあった料金プランを選ぼう</heading-two>

      <div class="contents-box">
        <talk-group class="_mr-md-20">
          <talk-box src="sv013/avatar-a.gif">料金プランを見直すときには、大きく2つのパターンに分かれるの。パターンにあったプランを選ぶのがポイントだよ！</talk-box>
          <talk-box src="sv013/avatar-a.gif">Bさんは、データ通信量がオーバーして通信速度制限がかかってしまったことはある？</talk-box>
          <talk-box src="sv013/avatar-b.gif">そういえば、ときどきあるな。先月なんて、追加でデータ容量をチャージしてチャージ料を支払ったよ…</talk-box>
          <talk-box src="sv013/avatar-a.gif">データチャージを何度もして、請求額が増えてて驚くことあるよね…私もauショップに相談にいったんだけど、いろいろなプランがあるから、使い方にあったプランを提案してもらうといいよ</talk-box>
          <talk-box src="sv013/avatar-a.gif">毎月の請求内容を確認してみて通話料や利用料にバラつきはないかな？</talk-box>
          <talk-box src="sv013/avatar-b.gif">普段はデータ通信をそんなに使わないけど、年末年始や旅行に出かけたときに使いすぎて、通信速度制限がかかってしまったような…</talk-box>
        </talk-group>

        <contents-card class="-orange _mb-sm-30 _ml-md-20">
          <div class="card-header">
            <icon-box src="light-orange" class="-md _mb-sm-10"></icon-box>
            <h3 class="heading -orange">通信料を見直すパターン2つ</h3>
          </div>
          <div class="card-body">
            <div class="card-groups">
              <div class="bg-box">
                <img src="@/assets/images/sv/sv013/01.gif" class="number img-fluid" alt="">
                通信制限がかかって通信速度が低下することが
                しばしばある
              </div>
              <div class="triangle"></div>
              <div class="border _mb-md-50 _mb-sm-40">
                <span class="txt01">定額制プランの検討を！</span>
              </div>
              <div class="bg-box">
                <img src="@/assets/images/sv/sv013/02.gif" class="number img-fluid" alt="">
                毎月の請求額にバラつきがある
              </div>
              <div class="triangle"></div>
              <div class="border">
                <span class="txt01">データ利用量にあわせて<br>毎月の利用料金が変動するプランを！</span>
              </div>
            </div>
          </div>
        </contents-card>
      </div>

      <talk-group>
        <talk-box src="sv013/avatar-a.gif">それなら、使った分だけ支払うプランがいいかも！auにはデータ利用量に応じて毎月の利用料金が変動するプランもあるから、Bさんみたいな人にはおすすめだよ！
          <a href="https://www.au.com/mobile/charge/pr/newplan/" target="_blank" class="-next -link">詳しくはこちら</a> ＞
        </talk-box>
        <talk-box src="sv013/avatar-b.gif">自分の使い方に合わせてプランを見直せば、年単位でまとまった金額を節約できるね！さっそく見直してみよう！</talk-box>
      </talk-group>
      <div class="_mb-md-60 _mb-sm-40">
        <small>※au PAY スマートローンのご契約・ご利用には審査がございます。審査状況によりご希望に添えない場合がございますので、あらかじめご了承ください。</small>
      </div>

      <div class="container">
        <btngroup-single class="_mb-md-60 _mb-sm-40">
          <btn-main class="-normal -lg" routerName="sv002">
            au PAY スマートローンの特徴について
          </btn-main>
        </btngroup-single>
      </div>
      <list-group class="_mb-md-120 _mb-sm-60">
        <list-item class="normal">au PAY スマートローンは、au回線をお持ちでない方でもご利用いただけます。</list-item>
        <list-item class="normal"><a href="https://loan.kddi-fs.com/apply" class="-next -link">詳しいお申し込み条件はこちら ＞</a></list-item>
      </list-group>
      <cv-box class="-cv _mb-md-120 _mb-sm-60"/>
    </div>

    <hr class="_mb-120 _mb-sm-60" />

    <div class="container">
      <heading-two>おすすめ記事</heading-two>

      <card-groups class="-image-top-list">
        <card-box router-name="sv016" class="-image-top">
          <card-header>
            <card-image class="-orange"><img src="@/assets/images/sv/sv016/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">Pontaポイントでスマートな暮らしを！？</h3>
          </card-header>
          <card-body>お借り入れ方法は、au PAY 残高へのチャージがおすすめ！Pontaポイントをためて賢く暮らそう！</card-body>
        </card-box>
        <card-box router-name="sv014" class="-image-top">
          <card-header>
            <card-image class="-orange"><img src="@/assets/images/sv/sv014/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">auでんきでスマートに省エネ！Pontaポイントもたまる！</h3>
          </card-header>
          <card-body>auでんきに乗り換えれば、毎月の電気利用量に応じてPontaポイントがたまる！アプリの活用で省エネも。</card-body>
        </card-box>
        <card-box router-name="sv009" class="-image-top">
          <card-header>
            <card-image class="-green"><img src="@/assets/images/sv/sv009/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">ローンにおける金利の仕組みとは？</h3>
          </card-header>
          <card-body>「金利・利息・実質年率ってなんだろう？」いまさら聞けないローンのキホンについて！</card-body>
        </card-box>
      </card-groups>

    </div><!-- container -->
  </div>
</template>

<script>

import ContentsHeader from '../components/contents/ContentsHeader'
import ContentsIntro from '../components/contents/ContentsIntro'
import HeadingTwo from '../components/heading/HeadingTwo'
import TalkGroup from '../components/contents/TalkGroup'
import TalkBox from '../components/contents/TalkBox'
import ContentsCard from '../components/contents/ContentsCard'
import IconBox from '../components/icons/icon-box'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'
import CvBox from '../components/box/CvBox'
import CardGroups from '../components/card/CardGroups'
import CardBox from '../components/card/CardBox'
import CardHeader from '../components/card/CardHeader'
import CardImage from '../components/card/CardImage'
import CardBody from '../components/card/CardBody'
export default {
  name: 'Sv-013',
  metaInfo: {
    title: '携帯電話の料金を見直しておトクに節約！｜auサービスでもっとおトクに！',
    meta: [
      {name: 'description', content: 'auサービスでおトクに！通信料の見直しで節約する方法について。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,携帯料金,電話代,見直し'}
    ]
  },
  components: {
    CardBody,
    CardImage,
    CardHeader,
    CardBox,
    CardGroups,
    CvBox,
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    IconBox,
    ContentsCard,
    TalkBox,
    TalkGroup,
    HeadingTwo,
    ContentsIntro,
    ContentsHeader
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'root'
      },
      {
        text: '知っておきたい！ローンについて',
        routerName: 'sv003'
      },
      {
        text: 'auサービスでもっとおトクに！',
        routerName: 'sv044'
      },
      {
        text: '携帯電話の料金を見直しておトクに節約！',
        active: true
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/stylesheets/styles";

.contents-card {
  >.card-body {
    background-color: #fff;
    border-radius: 10px;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 30px;
    @include mq-up(md) {
      padding-left: 50px !important;
      padding-right: 50px !important;
    }
    >.txt01 {
      font-size: 12px;
      word-break:break-all;
      @include mq-up(md) {
        margin-bottom: 25px;
        font-size: 14px;
      }
    }
    >.card-groups {
      display: flex;
      @include mq-down(md) {
        flex-wrap: wrap;
      }
      @include mq-up(md) {
        justify-content: space-between;
        align-items: center;
      }
      >.card-box {
        @include mq-up(md) {
          width: 50%;
        }
        >.card-image {
          margin: 0 auto;
          @include mq-up(md) {
            width: 80%;
          }
        }
        >.card-body {
          >.list-group {
            display: flex;
            flex-wrap: wrap;
            >.list-item {
              width: 50%;
              @include mq-down(md) {
                padding-right: 20px;
              }
            }
          }
        }
      }
    }
  }
}

.contents-box {
  display: flex;
  align-items: flex-start;
  @include mq-down(md) {
    flex-wrap: wrap;
  }
  >.talk-group {
    @include mq-up(md) {
      width: 50%;
    }
  }
  >.contents-card {
    @include mq-up(md) {
      width: 50%;
    }
    >.card-body {
      padding-top: 50px !important;
      padding-bottom: 50px !important;
      >.card-groups {
        @include mq-up(md) {
          flex-direction: column;
        }
        >.bg-box {
          position: relative;
          background-color: $light;
          padding: 20px 35px;
          margin-bottom: 20px;
          border-radius: 5px;
          text-align: center;
          @include mq-up(md) {
            padding: 30px 50px;
          }
          >.number {
            width: 30px;
            position: absolute;
            top: -11px;
            left: -11px;
            @include mq-up(md) {
              width: 40px;
              top: -12px;
              left: -12px;
            }
          }
        }
        >.triangle {
          border-style: solid;
          border-width: 20px 40px 0 40px;
          border-color: #dddddd transparent transparent transparent;
          margin: 0 auto 20px;
        }
        >.border {
          border: 1px solid $primary;
          border-radius: 5px;
          font-weight: bold;
          text-align: center;
          color: $primary;
          padding-left: 10px;
          padding-right: 10px;
          margin: 0 auto;
          .txt01 {
            font-size: 16px;
            background-color: $white;
            padding: 5px 12px;
            display: inline-block;
            margin-top: -1px;
            margin-bottom: -1px;
            @include mq-up(md) {
              font-size: 20px;
              padding: 5px 30px;
            }
          }
        }
      }
    }
  }
}

a {
  &.-link {
    &:hover {
      text-decoration: underline;
      color: $orange;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Sv013.vue